/* Polsk katalog for locale-autopilot-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'ap.review.completed': 'Sprawdzone / zatwierdzone',
  'ap.review.reviewApproved': 'Kontrola zatwierdzona',
  'ap.review.approvedNotBooked': 'Zatwierdzone · czeka na zaksięgowanie',
  'ap.review.booked': 'Zaksięgowano',
  'ap.review.checked': 'Sprawdzone',
  'ap.review.queueError': 'Nie udało się odświeżyć kolejki zadań. Przegląd może być niekompletny. Spróbuj ponownie, zanim zaczniesz przetwarzać propozycje.',
  'ap.review.retry': 'Spróbuj ponownie',
  'ap.review.overduePeriods': 'Przekroczone terminy: {{count}}',
  'ap.review.overduePeriod': '1 termin został przekroczony',
  'ap.review.overdueDetails': 'Zaległe punkty do obsłużenia: {{count}}. Złożenie: {{submissions}}. Płatność: {{payments}}.',
  'ap.review.deadlinePoints': 'Zaległe punkty: {{overdue}}, nadchodzące: {{upcoming}}',
  'ap.review.missingStatements': 'Brak wyciągów bankowych',
  'ap.review.missingStatementsPeriod': 'Dla tych kont brakuje wyciągu bankowego za {{period}}.',
  'ap.monthControl.liveTitle': 'Bieżący miesiąc',
  'ap.monthControl.liveBlockedReason': 'Miesiąc jeszcze trwa. Możesz na bieżąco przetwarzać i zatwierdzać pozycje, ale finalizacja będzie dostępna po końcu miesiąca.',
  'ap.cancelEntry': 'Anuluj księgowanie',
  'ap.saveEntry': 'Zapisz księgowanie',
  'ap.suggestion': 'Propozycja SuperPlumma',
  'ap.amountIncVat': 'Kwota (z VAT)',
  'ap.saveCorrection': 'Zapisz korektę',
  'ap.correct': 'Popraw',
  'ap.openInPayroll': 'Otwórz w płacach',
  'ap.payrollLines': 'Pozycje płacowe',
  'ap.hoursCount': 'Liczba godzin',
  'ap.hourlyRate': 'Stawka godzinowa',
  'ap.monthlyGross': 'Wynagrodzenie miesięczne (brutto)',
  'ap.holidayPayAccrued': 'Rezerwa na dodatek urlopowy (12 %)',
  'ap.employerCosts': 'Koszty pracodawcy',
  'ap.employerContribution': 'Składka pracodawcy (14,1 %)',
  'ap.mandatoryPension': 'Obowiązkowa pracownicza emerytura (2 %)',
  'ap.approveAndFile': 'Zatwierdź i złóż',
  'ap.vatReturnTitle': 'MVA-melding (deklaracja VAT)',
  'ap.post': 'Pozycja',
  'ap.checkPost': 'Sprawdź pozycję',
  'ap.allPostsChecked': 'Wszystkie pozycje zostały sprawdzone.',
  'ap.registerAsset': 'Zarejestruj aktywo',
  'ap.backToAssets': 'Wróć do aktywów',
  'ap.confirmAsset': 'Potwierdź aktywo',
  'ap.registeredAutomatically': 'Zarejestrowano automatycznie',
  'ap.balanceGroup': 'Grupa salda',
  'ap.amountExVat': 'Kwota (bez VAT)',
  'ap.registeredFrom': 'Zarejestrowano z',
  'ap.registeredAssets': 'Zarejestrowane aktywa',
  'ap.approveRegistrations': 'Zatwierdź rejestracje',
  'ap.saveAllAndApprove': 'Zapisz wszystko i zatwierdź',
  'ap.skip': 'Pomiń',
  'ap.skipped': 'Pominięto',
  'ap.amountIncVatShort': 'Kwota z VAT',
  'ap.openVoucherFull': 'Otwórz dokument w pełnym rozmiarze',
  'ap.security': 'Bezpieczeństwo',
  'ap.dragVoucherHere': 'Przeciągnij tutaj dokument ze skrzynki odbiorczej',
  'ap.approve': 'Zatwierdź',
  'ap.dragVoucherOntoLine': 'Przeciągnij dokument na pozycję, z którą chcesz go powiązać.',
  'ap.approveTask': 'Zatwierdź zadanie',
  'ap.sent': 'Wysłano',
  'ap.sentCount': 'Wysłano: {{count}}',
  'ap.openVatReturn': 'Otwórz MVA-melding',
  'ap.openTask': 'Otwórz zadanie',
  'ap.reopenTask': 'Cofnij zatwierdzenie',
  'ap.rerun': 'Przejrzyj ponownie',
  'ap.rerunHelp': 'Ponownie pobiera kolejkę z Functions i odbudowuje listę agenta. Nic nie zostaje zaksięgowane ani zatwierdzone.',
  'ap.rerunDone': 'AI Księgowy ponownie przejrzał {{month}}.',
  'ap.rerunFailed': 'Nie udało się ponownie uruchomić przeglądu.',
  'ap.staleApproval': 'Zatwierdzono {{date}} · podstawa od tego czasu się zmieniła',
  'ap.bankConnection': 'Połączenie z bankiem',
  'ap.agent.invoice.title': 'Niewysłane faktury: {{count}}',
  'ap.agent.invoice.titleDone': 'Wszystkie faktury zostały wysłane',
  'ap.agent.invoice.desc': 'Szkice: {{drafts}}, gotowe, ale niewysłane: {{unsent}}.',
  'ap.agent.invoice.descDone': 'Brak szkiców i niewysłanych faktur w {{year}}.',
  'ap.agent.invoice.detail': 'Szkic nie jest ujęty jako przychód ani wysłany do klienta. Wysyłka i księgowanie odbywają się z listy faktur.',
  'ap.agent.invoice.action': 'Otwórz listę faktur',
  'ap.agent.invoice.lineDraft': 'Szkic · nieujęty jako przychód',
  'ap.agent.invoice.lineUnsent': 'Gotowa, ale niewysłana',
  'ap.agent.invoice.execute': 'Wyślij faktury ({{count}})',
  'ap.agent.invoice.choose': 'Wybierz faktury',
  'ap.agent.invoice.selectAll': 'Wybierz wszystkie, które można wysłać',
  'ap.agent.invoice.selectRow': 'Wybierz fakturę',
  'ap.agent.invoice.selectedCount': 'Wybrano: {{count}}',
  'ap.agent.invoice.sendableCount': 'Można wysłać: {{count}}',
  'ap.agent.invoice.finishDraftFirst': 'Szkic trzeba ukończyć, zanim będzie można go wysłać',
  'ap.agent.invoice.sendSelectedOne': 'Wyślij wybraną fakturę',
  'ap.agent.invoice.sendSelected': 'Wyślij wybrane faktury ({{count}})',
  'ap.agent.invoice.executeDone': 'faktury wysłane',
  'ap.agent.dunning.title': 'Przeterminowane faktury czekające na monit: {{count}}',
  'ap.agent.dunning.titleDone': 'Brak przeterminowanych faktur',
  'ap.agent.dunning.desc': 'Po terminie płatności pozostaje do zapłaty {{amount}} kr.',
  'ap.agent.dunning.descDone': 'Wszystkie wysłane faktury są w terminie lub opłacone.',
  'ap.agent.dunning.detail': 'Monity, opłaty za monit i odsetki za zwłokę wysyła się z listy faktur. AI Księgowy niczego nie wysyła samodzielnie.',
  'ap.agent.dunning.action': 'Otwórz listę faktur',
  'ap.agent.dunning.line': 'Po terminie (dni: {{days}}) · faktura {{num}}',
  'ap.agent.dunning.execute': 'Wyślij przypomnienia ({{count}})',
  'ap.agent.dunning.executeTitle': 'Wyślij przypomnienia o płatności',
  'ap.agent.dunning.executeWarn': 'Przypomnienia trafiają bezpośrednio do klientów i nie można ich wycofać. Otrzymają je także klienci, którzy właśnie zapłacili, ale płatność nie została jeszcze zarejestrowana.',
  'ap.agent.dunning.executeNote': 'Plumme nie wysyła monitu do tej samej faktury częściej niż co siedem dni i pomija faktury rozliczone lub bez adresu e-mail klienta.',
  'ap.agent.dunning.executeDone': 'przypomnienia wysłane',
  'ap.agent.inbox.title': 'Niezaksięgowane dokumenty w skrzynce odbiorczej: {{count}}',
  'ap.agent.inbox.titleDone': 'Skrzynka odbiorcza jest pusta',
  'ap.agent.inbox.desc': 'Gotowe do zaksięgowania: {{ready}}, do sprawdzenia: {{review}}.',
  'ap.agent.inbox.descAnalyzing': 'Dokumenty w trakcie odczytu: {{count}}.',
  'ap.agent.inbox.descDone': 'Żadne dokumenty nie czekają na obsługę.',
  'ap.agent.inbox.detail': 'Dokumenty są odczytywane automatycznie po otrzymaniu. Księgowanie i wybór kont zatwierdza się w skrzynce odbiorczej.',
  'ap.agent.inbox.action': 'Otwórz skrzynkę odbiorczą',
  'ap.agent.inbox.execute': 'Zaksięguj gotowe dokumenty ({{count}})',
  'ap.agent.inbox.executeDone': 'dokumenty zaksięgowane',
  'ap.agent.inbox.voucher': 'Dokument',
  'ap.agent.inbox.lineReady': 'Odczytany i gotowy do zaksięgowania',
  'ap.agent.inbox.lineReview': 'Wymaga sprawdzenia przed zaksięgowaniem',
  'ap.agent.reconcile.title': 'Nieuzgodnione miesiące: {{count}}',
  'ap.agent.reconcile.titleDone': 'Wszystkie zamknięte miesiące są uzgodnione',
  'ap.agent.reconcile.descEarly': 'W {{year}} nie zamknięto jeszcze żadnego miesiąca.',
  'ap.agent.reconcile.desc': 'Uzgodnione i zaksięgowane: {{closed}} z {{total}} zamkniętych miesięcy.',
  'ap.agent.reconcile.descDone': 'Rachunek firmowy jest uzgodniony do poprzedniego miesiąca włącznie.',
  'ap.agent.reconcile.detail': 'Miesiąc uznaje się za uzgodniony, gdy wyciąg z rachunku firmowego jest zaksięgowany i zarchiwizowany w module Bank. Uzgadnianie musi odbywać się chronologicznie.',
  'ap.agent.reconcile.action': 'Otwórz bank',
  'ap.agent.reconcile.titleBlockedOrder': 'Najpierw trzeba uzgodnić {{month}}',
  'ap.agent.reconcile.descBlockedOrder': 'Uzgadnianie odbywa się chronologicznie. Saldo otwarcia pochodzi z poprzedniego miesiąca, więc rozbieżność w nim byłaby tutaj niewidoczna.',
  'ap.agent.reconcile.detailBlockedOrder': 'Przejdź do modułu Bank i dokończ najstarszy nieuzgodniony okres. Wtedy ten miesiąc odblokuje się sam.',
  'ap.agent.reconcile.reasonBlockedOrder': 'Czeka na {{month}}',
  'ap.agent.reconcile.line': 'Brak uzgodnionego wyciągu z rachunku firmowego',
  'ap.agent.quality.title': 'Ustalenia kontroli jakości: {{count}}',
  'ap.agent.quality.titleDone': 'Brak ustaleń w kontroli jakości',
  'ap.agent.quality.desc': 'Zakupy bez dokumentu: {{missing}}, możliwe podwójne księgowania: {{duplicates}}.',
  'ap.agent.quality.descDone': 'Wszystkie zakupy w {{year}} mają dokument i nie znaleziono możliwych podwójnych księgowań.',
  'ap.agent.quality.detailVat': 'Zakupy bez dokumentu odpowiadają {{vat}} kr odliczenia VAT, które może zostać zakwestionowane podczas kontroli.',
  'ap.agent.quality.detail': 'Możliwe podwójne księgowania to zakupy z tym samym dostawcą, kwotą i datą. Trzeba je ocenić ręcznie, zanim cokolwiek zostanie anulowane.',
  'ap.agent.quality.action': 'Otwórz transakcje',
  'ap.agent.quality.purchase': 'Zakup',
  'ap.agent.quality.lineDuplicate': 'Księgowania z tym samym dostawcą, kwotą i datą: {{count}}',
  'ap.agent.quality.lineMissing': 'Brak dokumentu · otwórz zakup, aby przesłać lub powiązać dokumentację',
  'ap.agent.deadline.titleOverdue': 'Przekroczone terminy: {{count}}',
  'ap.agent.deadline.title': 'Zbliżające się terminy: {{count}}',
  'ap.agent.deadline.titleDone': 'Brak terminów w ciągu najbliższych 30 dni',
  'ap.agent.deadline.desc': 'Najbliższy termin: {{name}} {{date}}.',
  'ap.agent.deadline.descOverdue': 'Nierozliczone zaległe zgłoszenia: {{count}}.',
  'ap.agent.deadline.descDone': 'Wszystkie zgłoszenia z terminem w ciągu 30 dni zostały złożone.',
  'ap.agent.deadline.lineNotFiled': 'Po terminie · nie złożono',
  'ap.agent.deadline.lineNotPaid': 'Po terminie · nie oznaczono jako zapłacone',
  'ap.agent.deadline.detail': 'Terminy zależą od okresu VAT i formy prawnej firmy. Składanie odbywa się w sekcji Zgłoszenia.',
  'ap.agent.deadline.action': 'Otwórz zgłoszenia',
  'ap.agent.deadline.lineOverdue': 'Po terminie (dni: {{days}})',
  'ap.agent.deadline.line': 'Pozostało dni: {{days}}',
  'ap.agent.annualDeadline.subjectMany': 'Zgłoszenia: {{count}}',
  'ap.agent.annualDeadline.titleDone': 'Terminy w miesiącu {{month}} są rozliczone',
  'ap.agent.annualDeadline.titleOverdue': '{{subject}} – nie złożono, termin minął',
  'ap.agent.annualDeadline.title': '{{subject}} – termin w miesiącu {{month}}',
  'ap.agent.annualDeadline.desc': '{{name}} za {{year}} – termin {{date}}.',
  'ap.agent.annualDeadline.descDone': 'Wszystkie zgłoszenia z terminem w miesiącu {{month}} oznaczono jako złożone.',
  'ap.agent.annualDeadline.detail': 'Termin przypada w roku następującym po roku podatkowym, więc dotyczy to rozliczenia za {{year}} — nie {{calendarYear}}. Ten wiersz nie blokuje zatwierdzenia miesiąca.',
  'ap.agent.annualDeadline.action': 'Otwórz',
  'ap.agent.annualDeadline.lineFiled': 'Oznaczono jako złożone',
  'ap.agent.annualDeadline.execute': 'Oznacz jako złożone poza Plumme',
  'ap.agent.annualDeadline.executeTitle': 'Oznacz aksjonærregisteroppgave jako złożoną',
  'ap.agent.annualDeadline.executeWarn': 'Plumme niczego nie wysyła. To tylko odnotowuje, że zgłoszenie złożono gdzie indziej, aby termin przestał ostrzegać.',
  'ap.agent.annualDeadline.executeNote': 'Aksjonærregisteroppgave (RF-1086) składa się z systemu użytkownika końcowego lub przez Altinn. Spółdzielnie mieszkaniowe są zwolnione, a spółki, w imieniu których składa Euronext VPS, nie składają jej samodzielnie.',
  'ap.agent.annualDeadline.executeDone': 'oznaczono',
  'ap.agent.annualDeadline.statusDetail': '{{subject}} należy obsłużyć w procesie zamknięcia roku.',
  'ap.agent.mileage.title': 'Przejazdy w ewidencji przebiegu bez dokumentacji: {{count}}',
  'ap.agent.mileage.titleOk': 'Udokumentowane przejazdy w ewidencji przebiegu: {{count}}',
  'ap.agent.mileage.titleEmpty': 'Brak zarejestrowanych przejazdów w {{year}}',
  'ap.agent.mileage.desc': 'Ewidencja przebiegu daje {{amount}} kr odliczenia w {{year}}.',
  'ap.agent.mileage.descEmpty': 'Jazdy służbowe można odliczyć, ale tylko gdy każdy przejazd ma datę, trasę, cel i kilometry.',
  'ap.agent.mileage.detail': 'Ewidencja przebiegu musi zawierać dla każdego przejazdu datę, skąd i dokąd, cel oraz liczbę kilometrów. Przejazdy bez tych danych mogą zostać odrzucone.',
  'ap.agent.mileage.action': 'Otwórz ewidencję przebiegu',
  'ap.agent.mileage.trip': 'Przejazd bez trasy',
  'ap.agent.mileage.lineNoPurpose': 'Brak celu',
  'ap.agent.mileage.lineNoKm': 'Brak kilometrów',
  'ap.agent.mileage.lineNoRoute': 'Brak trasy',
  'ap.agent.match.title': 'Wiersze bankowe bez dowodu księgowego: {{count}}',
  'ap.agent.match.titleDone': 'Wszystkie wiersze bankowe mają dowód księgowy',
  'ap.agent.match.desc': 'Dokumenty w skrzynce odbiorczej, które mogą pasować: {{count}}.',
  'ap.agent.match.descDone': 'Żaden wiersz bankowy nie wymaga dokumentacji.',
  'ap.agent.match.detail': 'Dowód księgowy jest łączony automatycznie tylko wtedy, gdy pasuje do dokładnie jednego wiersza bankowego, a ten wiersz do dokładnie jednego dowodu. W razie wątpliwości wybierasz sam.',
  'ap.agent.match.action': 'Otwórz bank',
  'ap.agent.match.line': 'Brak dowodu księgowego',
  'ap.agent.match.execute': 'Połącz dokumenty automatycznie',
  'ap.agent.match.executeTitle': 'Połącz dokumenty z wierszami bankowymi',
  'ap.agent.match.executeWarn': 'Dokumenty zostaną dołączone jako dokumentacja do wierszy bankowych. Nic nie zostanie zaksięgowane — nastąpi to dopiero przy uzgadnianiu wyciągu.',
  'ap.agent.match.executeNote': 'Łączone są tylko jednoznaczne dopasowania: dokument musi pasować do jednego wiersza bankowego, a wiersz do jednego dokumentu. Reszta czeka na ręczny wybór.',
  'ap.agent.match.executeDone': 'dokumenty połączone',
  'ap.agent.contacts.supplier': 'dostawcy',
  'ap.agent.contacts.customer': 'klienci',
  'ap.agent.contacts.title': 'Brakujący w rejestrze ({{noun}}): do {{count}}',
  'ap.agent.contacts.titleDone': 'Wszyscy {{noun}} są zarejestrowani',
  'ap.agent.contacts.desc': 'Nazwy powtarzające się w księgach, których nie ma w rejestrze.',
  'ap.agent.contacts.descDone': 'Brak powtarzających się nazw spoza rejestru.',
  'ap.agent.contacts.detail': 'Tworzone są tylko nazwa i numer organizacyjny. E-mail, telefon i adres uzupełniasz sam — Plumme nie zgaduje danych kontaktowych, które mogłyby trafić na fakturę.',
  'ap.agent.contacts.openSuppliers': 'Otwórz dostawców',
  'ap.agent.contacts.openCustomers': 'Otwórz klientów',
  'ap.agent.contacts.line': 'Księgowania: {{count}}',
  'ap.agent.contacts.execute': 'Utwórz brakujących: {{noun}}',
  'ap.agent.contacts.executeTitle': 'Dodaj do rejestru: {{noun}}',
  'ap.agent.contacts.executeWarn': 'Nazwy zostaną utworzone w rejestrze. Istniejące księgowania nie zostaną połączone automatycznie — zrobisz to, otwierając wpis.',
  'ap.agent.contacts.executeNote': 'Plumme tworzy tylko nazwy, które powtarzają się co najmniej dwa razy, i pomija opisy płatności, takie jak „Visa” i „Vipps”.',
  'ap.agent.contacts.executeDone': 'utworzono',
  'ap.contact.supplierNumber': 'Nr dostawcy',
  'ap.contact.supplierNumberPh': 'Np. 20001',
  'ap.contact.supplierName': 'Nazwa dostawcy',
  'ap.contact.customerName': 'Nazwa klienta',
  'ap.contact.namePh': 'Nazwa',
  'ap.contact.customerNamePh': 'Np. Przykład AS',
  'ap.contact.org': 'Nr organizacyjny',
  'ap.contact.orgOptional': 'Nr organizacyjny (opcjonalnie)',
  'ap.contact.orgPh': '123 456 789',
  'ap.contact.supplierEmailPh': 'faktura@leverandor.no',
  'ap.contact.customerEmailPh': 'post@eksempel.no',
  'ap.contact.phonePh': '400 00 000',
  'ap.contact.address': 'Adres',
  'ap.contact.addressPh': 'Ulica i numer',
  'ap.contact.supplierAddressPh': 'Ulica, kod pocztowy i miejscowość',
  'ap.agent.tax.titleBlocked': 'Podstawa opodatkowania jest niedostępna',
  'ap.agent.tax.descBlocked': 'Dane księgowe za {{year}} nie zostały wczytane.',
  'ap.agent.tax.detail': 'Złożenie skattemelding wymaga integracji z Altinn, która nie jest jeszcze podłączona.',
  'ap.agent.tax.blocked': 'Brak danych księgowych',
  'ap.agent.tax.titleDone': 'Skattemelding za {{year}} została złożona',
  'ap.agent.tax.title': 'Podstawa opodatkowania za {{year}} jest obliczona',
  'ap.agent.tax.descEnk': 'Wynik przed opodatkowaniem: {{result}} kr. Jednoosobowa działalność jest opodatkowana u właściciela.',
  'ap.agent.tax.desc': 'Wynik przed opodatkowaniem {{result}} kr daje {{tax}} kr obliczonego podatku.',
  'ap.agent.tax.action': 'Otwórz skattemelding',
  'ap.agent.tax.lineResult': 'Wynik przed opodatkowaniem',
  'ap.agent.tax.lineTax': 'Obliczony podatek',
  'ap.agent.tax.lineLoss': 'Strata do przeniesienia',
  'ap.agent.annual.titleBlocked': 'Sprawozdanie finansowe jest niedostępne',
  'ap.agent.annual.descBlocked': 'Dane księgowe za {{year}} nie zostały wczytane.',
  'ap.agent.annual.blocked': 'Brak danych księgowych',
  'ap.agent.annual.titleNotRequired': 'Firma nie ma obowiązku sporządzania sprawozdania finansowego',
  'ap.agent.annual.descNotRequired': 'Jednoosobowa działalność składa zamiast tego næringsspesifikasjon razem ze skattemelding.',
  'ap.agent.annual.action': 'Otwórz sprawozdanie finansowe',
  'ap.agent.annual.stepDocument': 'Dokument sprawozdania finansowego',
  'ap.agent.annual.stepBoard': 'Protokół zarządu',
  'ap.agent.annual.stepAssembly': 'Protokół zgromadzenia wspólników',
  'ap.agent.annual.stepSigned': 'Podpisanie',
  'ap.agent.annual.titleDone': 'Sprawozdanie finansowe za {{year}} zostało złożone',
  'ap.agent.annual.title': 'Pozostałe kroki sprawozdania finansowego za {{year}}: {{count}}',
  'ap.agent.annual.titleReady': 'Sprawozdanie finansowe za {{year}} jest gotowe do złożenia',
  'ap.agent.annual.descClosed': 'Rok obrotowy jest zamknięty.',
  'ap.agent.annual.descOpen': 'Rok obrotowy nie jest jeszcze zamknięty.',
  'ap.agent.annual.detail': 'Złożenie do Regnskapsregisteret wymaga integracji z Altinn, która nie jest jeszcze podłączona.',
  'ap.agent.annual.line': 'Nie ukończono',
  'ap.execute.title': 'Zaksięguj z AI Księgowy',
  'ap.execute.running': 'Księgowanie …',
  'ap.execute.warnTitleGeneric': 'Tej operacji nie można cofnąć',
  'ap.execute.warnTitle': 'To zaksięguje zapisy w Twoich księgach',
  'ap.execute.warnBody': 'Dokumenty zostaną zaksięgowane jako zakupy z kontem, VAT i metodą płatności z analizy dokumentów. Odpowiadasz za poprawność księgowań i musisz je ręcznie anulować, jeśli coś będzie nie tak.',
  'ap.execute.checked': 'Plumme ponownie sprawdza każdy dokument przed zaksięgowaniem. Dokumenty, które nie spełniają wymagań, pozostają w skrzynce odbiorczej z uzasadnieniem.',
  'ap.execute.doneCount': '{{booked}} {{noun}}',
  'ap.execute.done': 'Zaksięgowane dokumenty: {{booked}}',
  'ap.execute.partialCount': '{{done}} {{skipped}} nie zostało wykonanych i wymaga dalszych działań.',
  'ap.execute.failed': 'Księgowanie nie zostało wykonane.',
  'ap.lastRun': 'Ostatni przegląd {{when}}',
  'ap.lastRunLabel': 'Ostatni przegląd',
  'ap.bankDataHelp': 'SuperPlumma korzysta z wyciągów bankowych zaimportowanych w sekcji Bank. Bezpośrednie połączenie z bankiem nie jest jeszcze dostępne – prześlij wyciąg w formacie XLSX lub CSV, aby wczytać linie bankowe.',
  'ap.bankData': 'Dane bankowe',
  'ap.bankStatementImported': 'Wyciąg bankowy zaimportowany',
  'ap.noBankData': 'Brak zaimportowanego wyciągu bankowego',
  'ap.noData': 'Brak danych',
  'ap.importBankStatement': 'Importuj wyciąg bankowy',
  'ap.loadingTitle': 'Wczytywanie księgowości …',
  'ap.loadingText': 'SuperPlumma czeka na dane z Twojej księgowości. Lista zadań pojawi się, gdy tylko liczby zostaną wczytane.',
  'ap.disconnectBank': 'Odłącz bank',
  'ap.connected': 'Połączono',
  'ap.noBankConnected': 'Brak połączonego banku',
  'ap.connectBankHelp': 'Połącz swój bank, aby SuperPlumma mogła księgować transakcje bankowe.',
  'ap.bankIdNote': 'Połączenie odbywa się bezpiecznie przez BankID.',
  'ap.missingBasis': 'Brak podstawy',
  'ap.rowDescMissing': 'Brakuje informacji, zanim AI Księgowy będzie mógł kontynuować.',
  'ap.rowBlockedReasonDefault': 'Wymaga konfiguracji lub danych',
  'ap.rowOpen': 'Otwórz',
  'ap.working': 'Przetwarzanie …',
  'ap.execute.queued': 'Dodano do kolejki. Zadanie wykona się, nawet jeśli zamkniesz stronę – otrzymasz powiadomienie po zakończeniu.',
  'ap.execute.queueFailed': 'Nie udało się dodać działania do kolejki.',
  'ap.job.done': 'Wykonano: {{booked}}.',
  'ap.job.donePartial': 'Wykonano: {{booked}} · {{skipped}} nie zostało wykonanych i wymaga dalszych działań.',
  'ap.job.failed': 'Działanie nie zostało wykonane.',
  'ap.waiting': 'Oczekuje',
  'ap.waitingDetail': 'Nie można jeszcze przetworzyć',
  'ap.waitingGroup.title': 'Oczekujący agenci: {{count}}',
  'ap.waitingGroup.titleOne': '{{agent}} oczekuje',
  'ap.waitingGroup.detail': 'Staną się aktualne, gdy okres będzie gotowy',
  'ap.oneLineNeedsControl': ' linia wymaga sprawdzenia',
  'ap.manyLinesNeedControl': ' linii wymaga sprawdzenia',
  'ap.readyHere': 'Gotowe: {{count}}',
  'ap.openWorklist': 'Otwórz listę zadań',
  'ap.controlWorklist': 'Sprawdź listę zadań',
  'ap.controlTask': 'Sprawdź',
  'ap.openPage': 'Otwórz stronę',
  'ap.waitsForPrevious': 'Oczekuje',
  'ap.nextStep': 'Następny krok',
  'ap.comeBackLater': 'Wróć później',
  'ap.solveBlocker': 'Usuń blokadę',
  'ap.getBankData': 'Pobierz dane bankowe',
  'ap.approved': 'Zatwierdzono',
  'ap.whichAgents': 'Których agentów chcesz włączyć?',
  'ap.allAgents': 'Wszyscy agenci',
  'ap.settings.enabledCount': 'Włączone: {{on}} z {{total}}',
  'ap.settings.intro': 'SuperPlumma i agenci na bieżąco pracują nad Twoją księgowością. Wybierz, którzy agenci mają Ci pomagać. Ustawienia możesz zmienić w dowolnym momencie. Pracę, która nie jest włączona, musisz wykonać ręcznie.',
  'ap.settings.allHelp': 'Włącz lub wyłącz wszystkich naraz.',
  'ap.permission.inbox.label': 'Agent skrzynki odbiorczej',
  'ap.permission.inbox.desc': 'Odczytuje paragony i faktury przychodzące e-mailem lub przesłane ręcznie i przygotowuje je do zaksięgowania.',
  'ap.permission.matching.label': 'Agent dokumentów',
  'ap.permission.matching.desc': 'Łączy dokumenty ze skrzynki odbiorczej z liniami bankowymi bez dokumentacji, gdy dopasowanie jest jednoznaczne.',
  'ap.permission.reconciliation.label': 'Agent uzgodnień',
  'ap.permission.reconciliation.desc': 'Dba o to, aby każdy zamknięty miesiąc był faktycznie uzgodniony i zaksięgowany względem rachunku operacyjnego.',
  'ap.permission.control.label': 'Agent kontroli',
  'ap.permission.control.desc': 'Szuka zakupów bez dokumentów i możliwych podwójnych księgowań.',
  'ap.permission.asset.label': 'Agent środków trwałych',
  'ap.permission.asset.desc': 'Proponuje środek trwały przy większych zakupach. Wybierasz ujęcie w kosztach lub grupę amortyzacyjną, zanim dokument zostanie zaksięgowany jeden raz.',
  'ap.permission.vendor.label': 'Agent dostawców',
  'ap.permission.vendor.desc': 'Tworzy nowych dostawców, gdy SuperPlumma wykryje powtarzające się księgowania od tego samego dostawcy.',
  'ap.permission.customer.label': 'Agent klientów',
  'ap.permission.customer.desc': 'Tworzy nowych klientów, gdy SuperPlumma wykryje sprzedaż do nieznanych klientów.',
  'ap.permission.invoice.label': 'Agent faktur',
  'ap.permission.invoice.desc': 'Pilnuje szkiców faktur i gotowych faktur, które nie zostały wysłane do klienta.',
  'ap.permission.dunning.label': 'Agent monitów',
  'ap.permission.dunning.desc': 'Śledzi przeterminowane faktury i wskazuje, które należy monitować w pierwszej kolejności.',
  'ap.permission.deadline.label': 'Agent terminów',
  'ap.permission.deadline.desc': 'Ostrzega o zbliżających się lub przekroczonych terminach złożenia.',
  'ap.permission.mileage.label': 'Agent ewidencji przebiegu',
  'ap.permission.mileage.desc': 'Sprawdza, czy przejazdy służbowe mają trasę, cel i kilometry, aby odliczenie było udokumentowane.',
  'ap.permission.vat.label': 'Agent VAT',
  'ap.permission.vat.desc': 'Uzgadnia VAT i przygotowuje MVA-melding do złożenia.',
  'ap.permission.tax.label': 'Agent podatkowy',
  'ap.permission.tax.desc': 'Wstępnie wypełnia skattemelding na podstawie Twojej księgowości.',
  'ap.permission.payroll.label': 'Agent płac',
  'ap.permission.payroll.desc': 'Śledzi listy płac oczekujące na zatwierdzenie. Obliczenia i zatwierdzanie odbywają się w module Płace.',
  'ap.permission.annual.label': 'Agent sprawozdania finansowego',
  'ap.permission.annual.desc': 'Przygotowuje sprawozdanie finansowe i noty przy zamknięciu roku.',
  'ap.beta': 'Beta',
  'ap.heroTitle': 'SuperPlumma wykonuje pracę – Ty masz kontrolę.',
  'ap.heroSub': 'Zobacz, co zostało, sprawdź propozycje i zatwierdź następny krok.',
  'ap.aboutHelp': 'SuperPlumma zbiera zadania i przygotowuje propozycje na podstawie dostępnych danych. Księgowanie i wysyłka wymagają Twojego zatwierdzenia. Przełącznik steruje automatycznym przeglądem, a nie składaniem deklaracji ani płatnościami.',
  'ap.enabledDescription': 'SuperPlumma co rano przegląda Twoją księgowość i zbiera to, co czeka. Wybierz obszary, którymi mają się zająć agenci. Nic nie zostanie zaksięgowane ani wysłane bez Twojego zatwierdzenia.',
  'ap.disabledDescription': 'Autopilot jest wyłączony. Włącz go, aby SuperPlumma przeglądała Twoją księgowość w tle.',
  'ap.monthOpenHelp': 'SuperPlumma na bieżąco przygotowuje propozycje przez cały miesiąc. Niektóre kroki czekają, aż okres będzie gotowy, ale wszystko aktualizuje się automatycznie, gdy pojawią się nowe dane.',
  'ap.monthControl.label': 'Kontrola miesiąca',
  'ap.monthControl.permissionDesc': 'Obsługuje linie bankowe, dokumenty, kontrahentów i możliwe środki trwałe oraz uzgadnia miesiąc w jednym procesie.',
  'ap.monthControl.blockedDesc': 'Brakuje danych bankowych. Dokumenty bez linii bankowej nadal można przetwarzać.',
  'ap.monthControl.actionableDesc': 'Pozostałe punkty w {{period}}: {{count}}. Linie bankowe, dokumenty, kontrahenci, środki trwałe i uzgodnienie są obsługiwane razem.',
  'ap.monthControl.doneDesc': 'Kontrola miesiąca {{period}} została zakończona.',
  'ap.monthControl.title': 'Kontrola miesiąca **{{period}}**',
  'ap.monthControl.detail': 'Przetwarzaj linie bankowe chronologicznie, łącz dokumenty, twórz brakujących kontrahentów i oceniaj możliwe środki trwałe w jednym miejscu. Zatwierdzenie jest odwracalne; ostateczne księgowanie nadal odbywa się przyciskiem „Uzgodnij i zaksięguj”.',
  'ap.monthControl.waitingDetail': 'Okres trwa — mogą jeszcze pojawić się nowe linie',
  'ap.monthControl.blockedReason': 'Brak wyciągu bankowego lub pokrycia bankowego',
  'ap.monthControl.action': 'Otwórz kontrolę miesiąca',
  'ap.monthControl.findingsEmpty': 'Brak możliwych odchyleń.',
  'ap.monthControl.finding.deviation': 'Możliwe odchylenie',
  'ap.monthControl.finding.missingVoucher': 'Brak dowodu księgowego',
  'ap.monthControl.finding.needsReview': 'Wymaga sprawdzenia przed uzgodnieniem.',
  'ap.monthControl.count.inboxOne': 'Dokumenty w skrzynce odbiorczej: {{count}}',
  'ap.monthControl.count.inboxMany': 'Dokumenty w skrzynce odbiorczej: {{count}}',
  'ap.monthControl.count.bankMissingVoucherOne': 'Linie bankowe bez dokumentu: {{count}}',
  'ap.monthControl.count.bankMissingVoucherMany': 'Linie bankowe bez dokumentu: {{count}}',
  'ap.monthControl.count.bankLineOne': 'Linie bankowe: {{count}}',
  'ap.monthControl.count.bankLineMany': 'Linie bankowe: {{count}}',
  'ap.monthControl.count.reconciliationOne': 'Uzgodnienia: {{count}}',
  'ap.monthControl.count.reconciliationMany': 'Uzgodnienia: {{count}}',
  'ap.monthControl.count.qualityOne': 'Ustalenia kontroli jakości: {{count}}',
  'ap.monthControl.count.qualityMany': 'Ustalenia kontroli jakości: {{count}}',
  'ap.monthControl.count.assetOne': 'Aktywa: {{count}}',
  'ap.monthControl.count.assetMany': 'Aktywa: {{count}}',
  'ap.monthControl.count.supplierOne': 'Dostawcy: {{count}}',
  'ap.monthControl.count.supplierMany': 'Dostawcy: {{count}}',
  'ap.monthControl.count.customerOne': 'Klienci: {{count}}',
  'ap.monthControl.count.customerMany': 'Klienci: {{count}}',
  'ap.monthControl.count.itemOne': 'Punkty: {{count}}',
  'ap.monthControl.count.itemMany': 'Punkty: {{count}}',
  'ap.monthControl.noDate': 'Bez daty',
  'ap.monthControl.action.paySupplierInvoice': 'Opłać fakturę dostawcy',
  'ap.monthControl.action.registerSupplierInvoice': 'Zarejestruj fakturę dostawcy',
  'ap.monthControl.action.invoicePayment': 'Płatność faktury',
  'ap.monthControl.action.registerSale': 'Zarejestruj sprzedaż',
  'ap.monthControl.action.registerPurchase': 'Zarejestruj zakup',
  'ap.monthControl.block.needsControl': 'Dokument musi zostać sprawdzony przed zaksięgowaniem.',
  'ap.monthControl.block.missingBookingType': 'Brak typu księgowania.',
  'ap.monthControl.block.missingInvoiceNumber': 'Brak numeru faktury.',
  'ap.monthControl.block.lowConfidence': 'Niska pewność analizy.',
  'ap.monthControl.block.manualReview': 'Dokument wymaga ręcznego sprawdzenia.',
  'ap.monthControl.edit.purchase': 'Zmień zakup',
  'ap.monthControl.edit.sale': 'Zmień sprzedaż',
  'ap.monthControl.edit.bankFee': 'Zmień opłatę',
  'ap.monthControl.edit.invoicePayment': 'Zmień płatność faktury',
});
